/**
 * Sum the the values or the mapped return value of mapFn from the given
 * IterableCollection.
 *
 * @function mapFn
 * @param {*} value each value of obj
 * @returns {number} a number to sum
 *
 * @param  {IterableCollection} obj
 * @param {mapFn} mapFn
 * @return {number}
 */
export default function sum (obj, mapFn = v => v) {
  if (!this.isIterable(obj)) {
    throw new Error(`Cannot sum non-iterable object: ${obj}`);
  }
  let total = 0;
  for (let value of this.values(obj)) {
    total += mapFn(value);
  }
  return total;
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/sum.js